<!--
 * @Description: 任务撤回列表
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <div>
    <table-render
      ref="revokeListTableRender"
      :config="config"
      :propData="propData"
      rowKey="id"
      height="52vh"
    >
      <div slot="batchAction" style="font-size:12px;color:#FF0000;">
        任务撤回后，任务记录中将不能再查询到本条任务记录。任务审核状态为："审核中"的任务，自然人用户可编辑后再次提交任务。
      </div>
    </table-render>
    <div class="footer">
      <div class="xrk-dialog__btns">
        <el-button type="info" @click="cancel" style="margin-right:80px">
          取消
        </el-button>
        <el-button type="primary" @click="cancel">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';
import { btLoading } from '@/Mixin/btLoading';
export default {
  mixins: [btLoading],
  name: 'revokeList',
  data() {
    return {
      timer: null,
      config: [],
      propData: {
        query: {
          projectType: this.$store.state.homeProject.projectType,
          projectId: this.$store.state.homeProject.id
          // startDt: this.startDt,
          // endDt: this.endDt
        }
      },
      selection: []
    };
  },
  props: {
    startDt: String,
    endDt: String
  },
  components: { tableRender },
  computed: {
    // 0为人 1为个体
    type() {
      return this.$store.state.homeProject.projectStructureType === 2 ? 1 : 0;
    }
  },
  watch: {},
  methods: {
    cancel() {
      this.$xrkDialog.remove();
    }
  },
  mounted() {
    const setRevokeId = () => {
      if (this.$refs['revokeListTableRender']) {
        let arr = null;
        try {
          arr = this.$refs['revokeListTableRender'].tableResp.list;
        } catch (err) {
          console.error(err);
        }
        this.timer = setTimeout(() => {
          if (Array.isArray(arr)) {
            localStorage.setItem('revokeId', (arr[0] || {}).id || 0);
          } else {
            setRevokeId();
          }
        }, 2000);
      }
    };
    setRevokeId();
  },
  created() {
    const configArr = [...config[this.type]];
    // try {
    //   const monthRangeIndex = configArr[0].childMenu[0].search.findIndex(
    //     item => item.id === 'monthrange'
    //   );
    //   if (monthRangeIndex > -1) {
    //     configArr[0].childMenu[0].search[monthRangeIndex].val = [
    //       this.startDt,
    //       this.endDt
    //     ];
    //   }
    // } catch (error) {}
    this.config = configArr;
  },
  destroyed() {
    this.timer && clearTimeout(this.timer);
  }
};
</script>

<style scoped lang="scss">
.select-all {
  cursor: pointer;
}
.footer {
  padding: 0 25px;
}
.footer-button-group {
  display: flex;
  justify-content: center;
}
</style>
